export const RequestStatus = {  
    Pendiente: { id: "48D7E357-567F-45B1-BA28-A7199F104F6C", nombre: "Pendiente" },
    Aprobada: { id: "E79B1536-02E6-4DC1-ABE2-9155B8A65949", nombre: "Aprobada" },
    Rechazada: { id: "A6337F1C-C89F-4ED4-A5A6-0B58D4458054", nombre: "Rechazada" },
    PropuestaIniciada: { id: "7BC05D84-644E-4D3C-B2BB-ACAB32E0F848", nombre: "Propuesta iniciada"}   
};

